import { Box, Collapse, LinearProgress, Typography } from "@mui/material";
import { FinancialAssetSubTypeFarsi } from "../../types/FinancialAssets";
import { toToman } from "../../utils/Utils";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { useState } from "react";
import { ThemeProvider } from "@mui/material/styles";
import { ltrTheme } from "../../layout/theme/theme";

const CardItem = (props) => {
  const { title, value, first } = props;
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        borderLeft: !first && ((theme) => `1px solid ${theme.palette.grey[6]}`),
      }}
    >
      <Typography variant="subtitle1" color="secondary.main">
        {title}
      </Typography>
      <Box mt={1}>{value}</Box>
    </Box>
  );
};

function AutoInvestmentFundStatusCard({ sx = [], ...props }) {
  const { item, first, wallet, disable } = props;
  const fund = item.fundInfo;
  const [open, setOpen] = useState(false);
  const items = [
    {
      title: "تعداد",
      value: (
        <Typography variant="h6" color="grey.2">
          {item.numberOfUnits}
        </Typography>
      ),
    },
    {
      title: "مانده تا خرید",
      value: (
        <Typography variant="h6" color="grey.2">{`${toToman(
          item.totalPrice - wallet.amount
        )} تومان`}</Typography>
      ),
    },
    {
      title: "کارمزد سامانه",
      value: (
        <Typography variant="h6" color="grey.2">{`${toToman(
          item.wage
        )} تومان`}</Typography>
      ),
    },
  ];
  return (
    <Box
      onClick={() => {
        first && setOpen((prev) => !prev);
      }}
      sx={[
        {
          position: "relative",
          width: "100%",
          p: "16px",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
        },
        !disable && {
          boxShadow: (theme) => theme.shadows[2],
          border: (theme) =>
            first ? `1px solid ${theme.palette.primary.main}` : null,
        },
        disable && {
          bgcolor: "grey.6",
          opacity: 0.5,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {first && !disable && (
        <Box sx={{ position: "absolute", top: 16, right: 16 }}>
          {open ? (
            <KeyboardArrowUp sx={{ color: "primary.main", height: 20 }} />
          ) : (
            <KeyboardArrowDown sx={{ color: "primary.main", height: 20 }} />
          )}
        </Box>
      )}
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <img width={56} height={56} src={fund.iconPath} />
        <Box sx={{ display: "flex", flexDirection: "column", ml: 1, flex: 1 }}>
          <Typography variant="body2" color="secondary.dark">
            {`${fund.name} - ${FinancialAssetSubTypeFarsi[fund.assetSubType]}`}
          </Typography>
          <Box sx={{ minHeight: 10, my: "4px", mr: "24px" }}>
            {first && !disable && (
              <ThemeProvider theme={ltrTheme}>
                <LinearProgress
                  sx={{
                    minHeight: 10,
                    borderRadius: 10,
                    backgroundColor: "grey.7",
                    "& .MuiLinearProgress-bar": {
                      borderRadius: 10,
                      background: (theme) =>
                        `linear-gradient(90deg, ${theme.palette.primary.main} 70%, ${theme.palette.primary.light} 100%)`,
                    },
                  }}
                  variant="determinate"
                  value={
                    (wallet.amount / item.totalPrice) * 100 > 100
                      ? 100
                      : (wallet.amount / item.totalPrice) * 100
                  }
                />
              </ThemeProvider>
            )}
          </Box>

          <Typography variant="subtitle1" color="grey.4">
            {`${toToman(item.totalPrice)} تومان (قیمت صدور تقریبی روز)`}
          </Typography>
        </Box>
      </Box>
      {first && (
        <Collapse in={open}>
          <Box sx={{ display: "flex", mt: 2 }}>
            {items
              .filter((item) => Boolean(item.value))
              .map((item, index) => {
                return (
                  <CardItem
                    key={index}
                    title={item.title}
                    value={item.value}
                    first={index === 0}
                  />
                );
              })}
          </Box>
        </Collapse>
      )}
    </Box>
  );
}

export default AutoInvestmentFundStatusCard;
